<template>
  <div class="page-query">
    <TableQuery title="制票工作台" :show-button="false" :show-extend="false">
      <el-form inline size="mini">
        <el-row>
          <el-col :lg="8">
            <el-form-item label="制票通知单类型">
              <el-select v-model="inf_type">
                <el-option
                  v-for="item in selectDataOptions['A0022']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </TableQuery>

    <div class="table-container">
      <TableCommon
        title="通知单"
        :custome-config="() => vxeShowCustom('xTable')"
        export-all
        export-page
      >
        <template #button>
          <table-button name="add" tip="新增" @click="toAdd" />
          <table-button name="export" tip="打印" @click="printDialog" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="240"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :filter-config="{ remote: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          @cell-dblclick="cellClick"
          @filter-change="filterChange"
        />
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="浏览制票通知单"
      width="70%"
      top="5vh"
    >
      <iframe :src="url" frameborder="0" style="width: 100%;height: 600px" />
      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmPrint"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { printInvoice } from '@/api/sap/make-invoice-sap'
import { hexToBytes } from '@/utils/frontExport'

export default {
  props: {
    workbenchList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDialog: false,
      url: '',
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'invo_infoid', title: '制票通知单号', filters: [{ label: '非空', value: 'notempty' }, { label: '为空', value: 'empty' }], filterMultiple: false },
          { field: 'customer', title: '订单客户编号' },
          { field: 'cust_name', title: '订单客户名称' },
          { field: 'customer_type_text', title: '订单客户类型' },
          { field: 'invo_customer', title: '开票客户编号' },
          { field: 'invo_cust_name', title: '开票客户名称' },
          { field: 'inv_type_text', title: '发票类型' }
        ],
        data: []
      },
      catchData: [],
      filterVal: '',
      inf_type: '',
      selectDataOptions: {}
    }
  },
  watch: {
    'workbenchList': {
      handler(nv) {
        this.gridOptions.data = nv
        this.catchData = nv
        this.filterData()
      },
      deep: true
    }
  },
  created() {
    this.gridOptions.data = this.workbenchList
    this.catchData = this.workbenchList
    this.getSelectDictDataOrigin('A0022')
  },
  methods: {
    toAdd() {
      if (!this.inf_type) {
        this.$message.warning('请选择制票通知单类型！')
        return
      }
      this.$emit('changeActive', 'checkeOrder', this.inf_type, [])
    },
    filterChange({ $event, values }) {
      const [value] = values
      this.filterVal = value
      this.filterData()
    },
    filterData() {
      if (this.filterVal === 'notempty') { // 返回所有有单号的数据
        // 隐藏空数据
        this.gridOptions.data = this.catchData.filter(v => v.invo_infoid)
      } else if (this.filterVal === 'empty') { // 返回空数据
        // 隐藏有单号的数据
        this.gridOptions.data = this.catchData.filter(v => !v.invo_infoid)
        console.log(this.gridOptions.data)
      } else { // 返回所有数据
        this.gridOptions.data = this.catchData
      }
    },
    printDialog() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (!data.length) return this.$message.warning('请选择有效数据！')
      printInvoice({
        user_bp: this.$store.getters.role.USER_BP,
        invo_infoid: data.map(v => v.invo_infoid)
      }).then(res => {
        this.showDialog = true
        var uint8Array = new Uint8Array(hexToBytes(res.data))
        var blob = new Blob([uint8Array], { type: 'application/pdf' })
        this.url = URL.createObjectURL(blob)
      })
    },
    confirmPrint() {
      this.$confirm('确认已经打印此制票通知单！', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(res => {
        const data = this.$refs.xTable.getCheckboxRecords()
        printInvoice({
          user_bp: this.$store.getters.role.USER_BP,
          invo_infoid: data.map(v => v.invo_infoid),
          mode: 'X'
        }).then(res => {
          this.showDialog = false
          this.queryData()
        })
      })
    },
    cellClick({ row }) {
      this.$emit('changeActive', 'entry', null, '', row)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/CreateInvoice.vue